import {
    FETCH_CHECKER_LIST_SUCCESS,
    FETCH_CHECKER_LIST_REQUEST,
    FETCH_CHECKER_LIST_ERROR,
    SHOW_CHECKER_LOADER,
    HIDE_CHECKER_LOADER,
} from './checker.constants';

export const fetchCheckerRequest = payload => ({
    type: FETCH_CHECKER_LIST_REQUEST,
    payload,
});

export const fetchCheckerSuccess = payload => ({
    type: FETCH_CHECKER_LIST_SUCCESS,
    payload,
});

export const fetchCheckerError = payload => ({
    type: FETCH_CHECKER_LIST_ERROR,
    payload,
});

export const showLoader = () => ({ type: SHOW_CHECKER_LOADER });

export const hideLoader = () => ({ type: HIDE_CHECKER_LOADER });
